define('modules/page_generator/page_renderer',['require','exports','module','modules/editor/models/editorstate','common/models/appstate','modules/editor/views/page','fontmanager','jquery','i18n','lib/util','env','common/jquery/config','ldsh!./templates/generator_popup','ldsh!./templates/generator_page','ldsh!./templates/generator_popup_preview','ldsh!./templates/generator_preview'],function (require, exports, module) {
  "use strict";
  var EditorState = require('modules/editor/models/editorstate'),
    AppState = require('common/models/appstate'),
    PageRenderView = require('modules/editor/views/page'),
    FontManager = require('fontmanager'),
    $ = require('jquery'),
    i18n = require('i18n'),
    util = require('lib/util'),
    config = require('env'),
    jQueryConfig = require("common/jquery/config");

  var PageRenderer = module.exports = function (variant) {
    this.variant = variant;

    //Save reference in EditorState
    EditorState.setVariant(variant);
  };

  _.extend(PageRenderer.prototype, {
    pageTemplate: function (model) {
      return this.getPageTemplate(model);
    },

    previewTemplate: function (model) {
      return this.getPreviewTemplate(model);
    },

    getPageTemplate: function (model) {
      return (
        EditorState.isCurrentStepPopup() ?
          require("ldsh!./templates/generator_popup") :
          require("ldsh!./templates/generator_page")
      )(model);
    },

    getPreviewTemplate: function (model) {
      return (
        EditorState.isCurrentStepPopup() ?
          require("ldsh!./templates/generator_popup_preview") :
          require("ldsh!./templates/generator_preview")
      )(model);
    },

    isPopup: function () {
      return this.model.get('role') === 'popup';
    },

    buildPixelsHTML: function () {
      var pixelsGroup = this.variant.getPropertyGroup('page:conversion').get("customizedPixel");

      if (pixelsGroup) {
        var pixelsArray = pixelsGroup.split(',');
        return $.map(pixelsArray, function (pixel) {
          var pixelSrc = $.trim(pixel);
          return pixelSrc ?
            '<img alt="pixel" src="' + pixelSrc + '" width="1" height="1" border="0" />' :
            '';
        }).join("\n");
      }
    },

    generateSteps: function () {
      return this.variant.content.map(this.generateStep, this);
    },

    generateStep: function (step) {
      var pageProps = this.variant.getPropertyGroup("page:defaults"),
        privacy = this.variant.getPropertyGroup("page:privacy"),
        language = pageProps.get("language"),
        generatedContent = this._renderPage(step);

      EditorState.setActivePage(step);

      var model = {
        stepId: step.get('step'),
        seo: EditorState.getActivePage().seoParameters.toJSON(),
        privacy: privacy.toJSON(),
        pageProperties: pageProps.toJSON(),
        popupProperties: this.getPopupStyles(step),
        fonts: FontManager.getCustomFontsLink(),
        styles: this._renderStyles(),
        elementStyles: generatedContent.elementStyles,
        scripts: this._renderScripts(),
        headScripts: this._renderHeadScripts(),
        socialScripts: this._renderSocialScripts(),
        facebookAppId: this.variant.getFBAppId(),
        linkedinAppId: this.variant.getLinkedInAppId(),
        googleReCaptchaURL: this.variant.getGoogleReCaptchaURL(),
        googleReCaptchaSiteKey: this.variant.getGoogleReCaptchaSiteKey(),
        externalPublicLibs: this.variant.getExternalLibs(),
        isoLanguage: this._getISOLanguageCode(language),
        content: generatedContent.html,
        errorMessage: i18n.t("common.formError_" + language),
        isContent: step.get("role") !== "confirmation",
        platform: this.variant.get("platform"),
        pixels: this.buildPixelsHTML(),
        serverValidation: i18n.t("common.serverValidationUrl"),
        jQueryURL: this._getJQueryURL()
      };

      return this.pageTemplate(model);
    },

    getPopupStyles: function (step) {
      if (step.get('role') !== 'popup') {
        return {};
      }

      var popupProps = this.variant.getPropertyGroup('page:popup').toJSON();
      popupProps.overlayRGBA = util.hexToRgba(popupProps.overlayColor, popupProps.overlayOpacity / 10);
      popupProps.width += !Number.isInteger(popupProps.width) && !popupProps.width.match(/\d*?%$/) ? 'px' : '';
      popupProps.height += !Number.isInteger(popupProps.height) && !popupProps.height.match(/\d*?%$/) ? 'px' : '';

      return popupProps;
    },

    generatePreview: function (stepId) {
      var pageProps = this.variant.getPropertyGroup('page:defaults'),
        privacyProps = this.variant.getPropertyGroup('page:privacy'),
        language = pageProps.get('language'),
        generatedContent;

      if (!stepId) {
        stepId = 0;
      }

      var step = this.variant.getContentForStep(stepId);
      EditorState.setActivePage(step);
      generatedContent = this._renderPage(step);

      var model = {
        stepId: step.get('step'),
        seo: EditorState.getActivePage().seoParameters.toJSON(),
        pageProperties: pageProps.toJSON(),
        popupProperties: this.getPopupStyles(step),
        privacy: privacyProps.toJSON(),
        fonts: FontManager.getCustomFontsLink(),
        styles: this._renderStyles(),
        elementStyles: generatedContent.elementStyles,
        scripts: this._renderScripts(),
        headScripts: this._renderHeadScripts(),
        socialScripts: this._renderSocialScripts(),
        facebookAppId: this.variant.getFBAppId(),
        linkedinAppId: this.variant.getLinkedInAppId(),
        externalPublicLibs: this.variant.getExternalLibs(),
        isoLanguage: this._getISOLanguageCode(language),
        content: generatedContent.html,
        errorMessage: i18n.t(("common.formError_" + language)),
        isContent: true,
        platform: this.variant.get("platform"),
        base: config.apiHost,
        bodyClass: 'ed-landing-editor',
        googleReCaptchaURL: this.variant.getGoogleReCaptchaURL(),
        googleReCaptchaSiteKey: this.variant.getGoogleReCaptchaSiteKey(),
        serverValidation: i18n.t("common.serverValidationUrl"),
        jQueryURL: this._getJQueryURL()
      };

      return this.previewTemplate(model);
    },

    _renderPage: function (pageModel) {
      //Configure TRUE render
      EditorState.setGenerateMode(true);
      var renderer = new PageRenderView({
        data: pageModel
      });
      renderer.render();
      //grab head scripts!!!
      var elementStyles = "";
      $("style.generated-style").each(function (index, el) {
        elementStyles += $(el).html() + "\n";
      });
      this._transformSource(renderer.$el);
      var content = renderer.$el.html();
      renderer.remove();
      //Remove TRUE render
      EditorState.setGenerateMode(false);
      return {
        html: content,
        elementStyles: elementStyles
      };
    },

    _getJQueryURL: function () {
      var jQueryVersion = this.variant.getPropertyGroup('page:jquery_selector').get('version');

      return jQueryConfig.getURLByVersion(jQueryVersion);
    },

    _renderScripts: function () {
      var res = '',
        activePage = EditorState.getActivePage();

      if (!activePage.scripts) {
        return res;
      }

      activePage.scripts.each(function (script) {
        if (script.get('head')) {
          return false;
        } else if (script.get('isTag')) {
          res += script.get('content');
        } else {
          res += this._surroundScriptContentWithTags(script.get('content'));
        }
      }, this);

      return res;
    },

    _surroundScriptContentWithTags: function (userScriptContent) {
      return "<script type=\"text/javascript\">\n" + userScriptContent + "\n</script>\n";
    },

    _renderHeadScripts: function () {
      var res = '',
        activePage = EditorState.getActivePage();

      if (!activePage.scripts) {
        return res;
      }

      if (AppState.isCorreoDirectAvailable() && this.variant.getCorreoDirect().get('active')) {
        res += "<script src='{{urlCorreoDirectPixel}}'></script>";
      }

      activePage.scripts.each(function (script) {
        if (!script.get('head')) {
          return false;
        } else if (script.get('isTag')) {
          res += script.get('content');
        } else {
          res += this._surroundScriptContentWithTags(script.get('content'));
        }
      }, this);

      return res;
    },

    _renderSocialScripts: function () {
      var activePage = EditorState.getActivePage(),
        socialPlugins = activePage.getActiveSocialPlugins();
      return _.reduce(socialPlugins, function (scripts, plugin) {
        return scripts += plugin.get("scriptTag") || "";
      }, "");
    },

    _renderStyles: function () {
      var res = "",
        activePage = EditorState.getActivePage();
      if (!activePage.styles) {
        return res;
      }

      activePage.styles.each(function (style) {
        var styleTag = "";
        if (style.get("isTag")) {
          styleTag += style.get("content") + "\n";
        } else {
          styleTag = "<style type=\"text/css\">\n";
          styleTag += style.get("content") + "\n";
          styleTag += "</style>\n";
        }
        res += styleTag;
      }, this);

      return res;
    },

    _getISOLanguageCode: function (lang) {
      return {
        "es": "es_ES",
        "it": "it_IT",
        "fr": "fr_FR",
        "pt": "pt_BR"
      }[lang];
    },

    _transformSource: function ($el) {
      //remove draggable
      $el.find("div[draggable]").removeAttr("draggable");
      //remove UI controls
      $el.find(".margin-control").remove();
      $el.find(".resize-box").remove();
      $el.find(".js-element-toolbar").remove();
      $el.find(".ed-position-box").remove();
    }
  });
});

